import { URL_SIGNIN_CLOUD, URL_SIGNIN_PRO, URL_SIGNIN_ASSOCIATE_CLOUD } from "../Utils/Strings/URL";
import * as actionType from "./Action_Type";

export const signIn_request = () => ({
    type            : actionType.SERVICE_SIGNIN_CLOUD_REQUEST,
    isFetching      : true
});
export const signIn_success = (prices) => ({
    type            : actionType.SERVICE_SIGNIN_CLOUD_SUCCESS,
    isFetching      : false,
    prices
});
export const signIn_error = (msgError) => ({
    type            : actionType.SERVICE_SIGNIN_CLOUD_ERROR,
    isFetching      : false,
    msgError
});

export function registerCloud(userData, invoiceData, paymentData, holdingData = {}){
    //Creo l'oggetto
    paymentData.address = paymentData.address || {};
    var data = {
        username        : userData.username,
        password        : userData.password,
        confirmPassword : userData.confirmPassword,
        email           : userData.email,
        UserID          : userData.id || null,
        Fatturazione    : invoiceData == null || invoiceData == {} ? null : {
            RagioneSociale  : invoiceData.ragioneSociale,
            Piva            : invoiceData.piva, 
            Indirizzo       : invoiceData.indirizzo,
            Email           : invoiceData.email,
            Citta           : invoiceData.citta,
            Provincia       : invoiceData.provincia,
            Cap             : invoiceData.cap
        },
        Pagamento       : {
            Email         : paymentData.email                  ,
            Paid          : paymentData.paid                   ,
            PayerID       : paymentData.payerID                ,
            PaymentID     : paymentData.paymentID              ,
            PaymentToken  : paymentData.paymentToken           ,
            City          : paymentData.address.city           ,
            Country_Code  : paymentData.address.coutry_code    ,
            Recipent_Name : paymentData.address.recipient_name ,
            State         : paymentData.address.state          ,
            Address1      : paymentData.address.line1          ,
            Address2      : paymentData.address.line2          ,
        },
        Holding         : {
            Nome        : holdingData.nome        || invoiceData.ragioneSociale,
            Descrizione : holdingData.descrizione || ""
        }
    }
    
    let config = {
        method  : 'POST',
        headers : { Accept: 'application/json', "Content-Type": "application/json" },
        body    : JSON.stringify(data)
    };
    
    return dispatch => {
      dispatch(signIn_request());

      return fetch(URL_SIGNIN_CLOUD, config)
        .then(response =>
          response.json().then(p_prices => ({ p_prices, response }))
        )
        .then(({ p_prices, response }) => {
          if (p_prices.Code != 200) {
            return Promise.reject(p_prices);
          } else {
            dispatch(signIn_success(p_prices.Data));
          }
        })
        .catch(err => {
            console.error(err.Message);
            dispatch(signIn_error(err.Message));
          }
        );
    };
};

export function registerAssociateCloudUser(userData, paymentData, holdingID ){
    //Creo l'oggetto
    paymentData.address = paymentData.address || {};
    var data = {
        username        : userData.AssociaUsername,
        Pagamento       : {
            Email         : paymentData.email                  ,
            Paid          : paymentData.paid                   ,
            PayerID       : paymentData.payerID                ,
            PaymentID     : paymentData.paymentID              ,
            PaymentToken  : paymentData.paymentToken           ,
            City          : paymentData.address.city           ,
            Country_Code  : paymentData.address.coutry_code    ,
            Recipent_Name : paymentData.address.recipient_name ,
            State         : paymentData.address.state          ,
            Address1      : paymentData.address.line1          ,
            Address2      : paymentData.address.line2          ,
        },
        Holding         : {
            ID          : holdingID,
        },
        IDRole    : userData.IDRole,
        IDAzienda : userData.IDAzienda
    }
    
    let config = {
        method  : 'POST',
        headers : { Accept: 'application/json', "Content-Type": "application/json" },
        body    : JSON.stringify(data)
    };
    
    return dispatch => {
      dispatch(signIn_request());

      return fetch(URL_SIGNIN_ASSOCIATE_CLOUD, config)
        .then(response =>
          response.json().then(p_prices => ({ p_prices, response }))
        )
        .then(({ p_prices, response }) => {
          if (p_prices.Code != 200) {
            return Promise.reject(p_prices);
          } else {
            dispatch(signIn_success(p_prices.Data));
          }
        })
        .catch(err => {
            console.error(err.Message);
            dispatch(signIn_error(err.Message));
          }
        );
    };
}

export function registerCloudFromUser(userData, paymentData, holdingData = {}){
    //Creo l'oggetto
    paymentData.address = paymentData.address || {};
    var data = {
        username        : userData.Username,
        password        : userData.Password,
        confirmPassword : userData.ConfirmPassword,
        email           : userData.Email,
        UserID          : userData.id || null,
        Pagamento       : {
            Email         : paymentData.email                  ,
            Paid          : paymentData.paid                   ,
            PayerID       : paymentData.payerID                ,
            PaymentID     : paymentData.paymentID              ,
            PaymentToken  : paymentData.paymentToken           ,
            City          : paymentData.address.city           ,
            Country_Code  : paymentData.address.coutry_code    ,
            Recipent_Name : paymentData.address.recipient_name ,
            State         : paymentData.address.state          ,
            Address1      : paymentData.address.line1          ,
            Address2      : paymentData.address.line2          ,
        },
        Holding         : {
            ID          : userData.IDHolding,
        },
        IDRole : userData.IDRole,
        IDAzienda : userData.IDAzienda
    }
    
    let config = {
        method  : 'POST',
        headers : { Accept: 'application/json', "Content-Type": "application/json" },
        body    : JSON.stringify(data)
    };
    
    return dispatch => {
      dispatch(signIn_request());

      return fetch(URL_SIGNIN_CLOUD, config)
        .then(response =>
          response.json().then(p_prices => ({ p_prices, response }))
        )
        .then(({ p_prices, response }) => {
          if (p_prices.Code != 200) {
            return Promise.reject(p_prices);
          } else {
            dispatch(signIn_success(p_prices.Data));
          }
        })
        .catch(err => {
            console.error(err.Message);
            dispatch(signIn_error(err.Message));
          }
        );
    };
};

export function registerPro(userData, invoiceData, paymentData){
    paymentData.address = paymentData.address || {};
    var data = {
        username        : userData.username,
        password        : userData.password,
        confirmPassword : userData.confirmPassword,
        email           : userData.email,
        UserID          : userData.id || null,
        Fatturazione    : invoiceData == null || invoiceData == {} ? null : {
            RagioneSociale  : invoiceData.ragioneSociale,
            Piva            : invoiceData.piva, 
            Indirizzo       : invoiceData.indirizzo,
            Email           : invoiceData.email,
            Citta           : invoiceData.citta,
            Provincia       : invoiceData.provincia,
            Cap             : invoiceData.cap
        },
        Pagamento       : {
            Email         : paymentData.email                  ,
            Paid          : paymentData.paid                   ,
            PayerID       : paymentData.payerID                ,
            PaymentID     : paymentData.paymentID              ,
            PaymentToken  : paymentData.paymentToken           ,
            City          : paymentData.address.city           ,
            Country_Code  : paymentData.address.coutry_code    ,
            Recipent_Name : paymentData.address.recipient_name ,
            State         : paymentData.address.state          ,
            Address1      : paymentData.address.line1          ,
            Address2      : paymentData.address.line2          ,
        },
    }
    
    let config = {
        method  : 'POST',
        headers : { Accept: 'application/json', "Content-Type": "application/json" },
        body : JSON.stringify(data)
    };
    return dispatch => {
      dispatch(signIn_request());

      return fetch(URL_SIGNIN_PRO, config)
        .then(response =>
          response.json().then(p_prices => ({ p_prices, response }))
        )
        .then(({ p_prices, response }) => {
          if (p_prices.Code != 200) {
            return Promise.reject(p_prices);
          } else {
            dispatch(signIn_success(p_prices.Data));
          }
        })
        .catch(err => {
            console.error(err.Message);
            dispatch(signIn_error(err.Message));
          }
        );
    };
};


// WEBPACK FOOTER //
// ./src/Actions/Action_ServiceRequest_Registrazione.js